<template>
  <v-card>
    <v-card-title class="headline">Sales Rewards Rules &amp; FAQs</v-card-title>
    <v-card-text>
      <ContentView contentKey="SALESPERSON_RULES_AND_FAQS" />
    </v-card-text>
  </v-card>
</template>

<script>
import ContentView from "../../gapp-components/components/common/content/ContentView.vue";
export default {
  name: "SalespersonRulesAndFaqs",
  metaInfo: {
    title: "Sales Rules and FAQs"
  },
  components: { ContentView }
};
</script>
